import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import Dashboard from './pages/dashboard/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import BookingPage from './pages/Booking/bookingPage';
import BookingForm from './pages/Booking/BookingForm';
import AdminDashboard from './pages/dashboard/AdminDashboard';

function App() {
  return (
    <Router>
      <Navbar />
      <main id="main-content" className="site-main">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />
        <Route path="/" element={<PrivateRoute><BookingPage /></PrivateRoute>} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route path="/bookingpage" element={<PrivateRoute><BookingPage /></PrivateRoute>} />
        <Route path="/booking-form" element={<PrivateRoute><BookingForm /></PrivateRoute>} />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            </PrivateRoute>
          }
        />
        <Route path="/dev-edit" element={<PrivateRoute><BookingPage /></PrivateRoute>} />
        <Route path="*" element={<PrivateRoute><BookingPage /></PrivateRoute>} />
      </Routes>
      </main>
      <footer className="site-footer"><span>Grand River Friendship Society</span><span>A place to gather. A space to belong.</span></footer>
    </Router>
  );
}

export default App;
